import Vue from 'vue'
import './plugins/axios'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'

//Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  data () {
      return {
        breadcrumbs: [],
        sidebarBg: "blue-grey"//blue-grey, deep-purple, indigo, cyan, teal, deep-orange
      }
    }
}).$mount('#app')
